/**
 * "Emoji" alanına yazılan değerin bir görsel/ikon linki mi yoksa gerçek bir
 * emoji karakteri mi olduğunu ayırt eder. Kullanıcı flaticon vb. bir ikon
 * linkini yapıştırdığında bunu ikon görseli olarak render edebilmek için kullanılır.
 */
export const isImageUrl = (value?: string): boolean => {
  const raw = String(value || '').trim();
  if (!raw) return false;
  if (raw.startsWith('data:image/')) return true;
  if (raw.startsWith('blob:')) return true;
  return /^(https?:)?\/\/\S+/i.test(raw);
};

/**
 * flaticon.com gibi doğrudan görsel dosyası vermeyen "sayfa" linklerini tespit
 * eder. Bu durumda kullanıcıya doğrudan görsel linkini yapıştırması söylenir.
 */
export const isNonImagePageUrl = (value?: string): boolean => {
  const raw = String(value || '').trim().toLowerCase();
  if (!isImageUrl(raw)) return false;
  if (raw.startsWith('data:image/')) return false;
  if (raw.startsWith('blob:')) return false;

  const hasImageExtension = /\.(png|jpe?g|gif|webp|svg|avif|ico)(\?|#|$)/i.test(raw);
  if (hasImageExtension) return false;

  // Bilinen ikon CDN'leri doğrudan görsel döndürür (uzantı olmasa bile).
  const knownImageCdn = /(cdn-icons|cdn\.|\.cdn|images\.|img\.|icons8\.com\/.*\.(png|svg))/i.test(raw);
  if (knownImageCdn) return false;

  return true;
};
